
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M3.813 3.813a8.75 8.75 0 1112.374 12.374A8.75 8.75 0 013.813 3.813zM10 2.75a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.355 7.33l-1.392 3.48a.75.75 0 01-.696.472H4.133a.75.75 0 010-1.5H5.76l1.42-3.55a1.283 1.283 0 012.397.05v.003l2.184 6.185 1.322-2.31a.75.75 0 01.651-.378h2.134a.75.75 0 010 1.5h-1.699l-1.341 2.344a1.284 1.284 0 01-2.324-.21L8.355 7.33z","clip-rule":"evenodd"}})])
          )
        }
      }
    